import { DownloadDebtValuationPayload } from '@pages/DebtPricer/components/DebtPricerContent/components/ReportDownloadPanel/types';
import {
  GetTransactionByIdRequestPayload,
  GetTransactionByIdSuccessPayload,
  SaveTradePayloadRequest,
  SaveTradePayloadSuccess,
  ValueTradePayloadRequest,
  ValueTradePayloadSuccess,
} from '@pages/DebtPricer/store/actions';
import { DebtLegState } from '@pages/DebtPricer/store/components/LegsReducer';
import { TradeSummaryState } from '@pages/DebtPricer/store/components/TradeSummaryReducer';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class DebtPricerAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async postBuildSchedule(payload: {
    leg: DebtLegState;
    trade_summary: TradeSummaryState;
  }) {
    return this.client.post('/v2/debt/pricer/build-schedule/', payload);
  }

  async fetchTrade({
    debt_id,
  }: GetTransactionByIdRequestPayload): Promise<
    AxiosResponse<GetTransactionByIdSuccessPayload>
  > {
    return this.client.get(`/v2/debt/pricer/${debt_id}/`);
  }

  async postSaveTrade({
    data,
  }: SaveTradePayloadRequest): Promise<
    AxiosResponse<{ data: SaveTradePayloadSuccess }>
  > {
    return this.client.post('/v2/debt/pricer/', data);
  }

  async postValueTrade({
    data,
  }: ValueTradePayloadRequest): Promise<
    AxiosResponse<ValueTradePayloadSuccess>
  > {
    return this.client.post('/v2/debt/pricer/value/', data);
  }

  async downloadDebtValuationReport(payload: DownloadDebtValuationPayload) {
    return this.client.post(
      '/v2/reporting/download-debt-valuation-report/',
      payload,
    );
  }
}
